import angular from "angular";
import ContactCardComponent from "./contact-card/contact-card";
import LibraryContactsPageComponent from "./library-contacts-page/library-contacts-page.component";
import ContactModalComponent from "./contact-modal/contact-modal";

const LibraryContactsModule = angular
  .module("modules.libraryContacts", [])
  .component("contactModal", ContactModalComponent)
  .component("contactCard", ContactCardComponent)
  .component("libraryContactsPage", LibraryContactsPageComponent);

export default LibraryContactsModule;
